/* TPC - cart insert offer handler.  BATCH 4d, 19 Aug.
 *
 * LOADED GLOBALLY from layout/theme.liquid: the cart drawer re-renders over AJAX and a
 * <script> inside injected markup never executes.
 *
 * THE ROW IS CLEARED HERE, not by the theme: Symmetry's merge (assets/main.js ~line 320) only
 * replaces a cart line when its data-merge-cache changes - key|quantity|line_price|selling_plan
 * for THAT line. Adding a different product does not change the cover's cache.
 *
 * THREE LAYERS, each closing a race the previous one did not:
 *   1. disabled attribute  - immediate visual state, stops the simple fast double-click.
 *   2. pendingGroups       - in-memory, survives an AJAX cart redraw that would otherwise hand
 *                            us freshly rendered ENABLED buttons mid-request.
 *   3. release AFTER merge - on a drawer add the flag is held until the drawer has actually
 *                            merged (Symmetry's cart-form.refreshFromHtml dispatches
 *                            on:cart:after-merge, which bubbles through cart-drawer), then
 *                            clearGroup runs a SECOND time.
 *
 * THE SAFETY TIMEOUT RELOADS, IT DOES NOT UNLOCK. An earlier version deleted the pending flag
 * after 4s, which was wrong: "the merge event has not fired yet" is not "it never will". On a
 * slow connection the drawer response could arrive at 4.5s, restore the pre-insert offer row,
 * and find it clickable again - the exact race layer 3 exists to close. Unconfirmed state is
 * resolved the same way as a failed add: reload, never re-enable.
 *
 * FAILURE = RELOAD, ALWAYS. Shopify can add the MAXIMUM AVAILABLE quantity and still return
 * 422 when a request exceeds stock, so a non-2xx is not proof the cart is unchanged.
 *
 * THE CART PAGE TRUMPS THE DRAWER. On /cart the drawer also exists (overlay-group), so an add
 * made inside the drawer while standing on /cart would refresh only the drawer and leave the
 * main page showing a stale subtotal and item count.
 */
(function () {
  if (window.tpcCartInsertBound) return;
  window.tpcCartInsertBound = true;

  var pendingGroups = Object.create(null);

  function cartAddUrl() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function inDrawer(el) {
    return !!(el.closest && el.closest('cart-drawer, .cart-drawer, .js-cart-drawer'));
  }

  function groupButtons(group, fallbackBtn) {
    if (!group) return [fallbackBtn];
    var list = document.querySelectorAll('.tpc-li[data-ci-group="' + group + '"] [data-ci-add]');
    return list.length ? list : [fallbackBtn];
  }

  function clearGroup(group, fallbackRow) {
    var rows = group ? document.querySelectorAll('.tpc-li[data-ci-group="' + group + '"]') : [];
    if (rows.length) {
      Array.prototype.forEach.call(rows, function (r) {
        if (r.parentNode) r.parentNode.removeChild(r);
      });
    } else if (fallbackRow && fallbackRow.parentNode) {
      fallbackRow.parentNode.removeChild(fallbackRow);
    }
  }

  function message(row, text) {
    if (!row) return;
    var note = row.querySelector('.tpc-li__note');
    if (note) note.textContent = text;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ci-add]') : null;
    if (!btn || btn.disabled) return;

    var row = btn.closest('.tpc-li');
    var group = row ? row.getAttribute('data-ci-group') : null;

    if (group && pendingGroups[group]) { e.preventDefault(); return; }

    var id = parseInt(btn.getAttribute('data-variant'), 10);
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    if (!id) return;

    e.preventDefault();
    e.stopPropagation();

    if (group) pendingGroups[group] = true;

    var locked = groupButtons(group, btn);
    var drawer = inDrawer(btn);
    var onCartPage = document.body.classList.contains('template-cart');

    Array.prototype.forEach.call(locked, function (b) { b.disabled = true; });
    btn.textContent = 'Adding...';

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('cart state unknown');
      return r.json();
    })
    .then(function () {
      clearGroup(group, row);

      if (onCartPage) {
        if (group) delete pendingGroups[group];
        window.location.reload();
        return;
      }

      if (drawer) {
        var safety;
        var afterMerge = function (ev) {
          if (ev && ev.target && ev.target.closest && !ev.target.closest('cart-drawer')) return;
          clearGroup(group, row);
          if (group) delete pendingGroups[group];
          document.removeEventListener('on:cart:after-merge', afterMerge);
          clearTimeout(safety);
        };
        // The add already succeeded and clearGroup has run. If the drawer never confirms its
        // refreshed state, RELOAD - do not release the flag. Unlocking on a timeout would let a
        // late merge restore a clickable offer row.
        safety = setTimeout(function () {
          document.removeEventListener('on:cart:after-merge', afterMerge);
          window.location.reload();
        }, 4000);

        document.addEventListener('on:cart:after-merge', afterMerge);
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        return;
      }

      if (group) delete pendingGroups[group];
      window.location.reload();
    })
    .catch(function () {
      message(row, 'Availability changed, refreshing your cart');
      window.location.reload();
    });
  }, true);
})();
